<script setup>
import Navbar from "./components/Navbar.vue";
import Footer from "./components/Footer.vue";
</script>

<template>
  <div class="flex flex-col min-h-screen bg-white dark:bg-gray-900 text-black dark:text-white">
    <Navbar />
    <router-view />
    <Footer />
  </div>
</template>

<style scoped></style>
